import script from "./FormMultiselect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormMultiselect.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./FormMultiselect.vue?vue&type=style&index=1&id=3df83262&lang=css"

const __exports__ = script;

export default __exports__